import React from "react";
import LoginForm from "./common/LoginForm";
import { connect } from "react-redux";
import {
  DetailsList,
  Spinner,
  SpinnerSize,
  Dialog,
  DialogFooter,
  ChoiceGroup,
  Button,
  ButtonType,
  CheckboxVisibility,
  TextField,
  DatePicker,
  Label,
  Dropdown,
  TagPicker,
  DetailsListLayoutMode,
  ConstrainMode,
  PrimaryButton,
  DefaultButton,
} from "office-ui-fabric-react";
import * as users from "../axios/users";
import { browserHistory } from "react-router";

import imgCity from "./imgs/city.jpg";
import imgLogo from "./imgs/login-logo.png";

import config from "../config";
import StatusBar from "./common/StatusBar";
import _ from "lodash";

import request from "axios";

export class ZipCodeAssignment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      isLoading: false,
      showDialogDelete: false,
      showComments: false,
      showReminderDate: false,
      columns: columns,
      data: {},
      zipCodes: [],
      zipCodesReassign: [],
    };
  }

  loadData() {
    this.props.dispatch(users.list());
    request.get(`${config.apiUrl}/zipcode/listcode`).then(({ data }) => {
      this.setState({
        zipCodes: data,
      });
    });
    request.get(`${config.apiUrl}/zipcode/list-reassign`).then(({ data }) => {
      this.setState({
        zipCodesReassign: data,
      });
    });
  }


  componentDidMount() {
    this.loadData();
  }

  close() {
    this.setState({
      showDialog: false,
      data: {},
    });
  }

  save() {
    var zc = [];
    try {
      var tagItems = this.refs.zipCodes.items;
      for (var i = 0; i < tagItems.length; i++) {
        if (zc.indexOf(tagItems[i].key) == -1) {
          zc.push(tagItems[i].key);
        }
      }
    } catch (ex) {}
    this.rowSelected.zipCodes = zc
      .filter((e) => e)
      .sort()
      .join(",");
    this.rowSelected.noOfZipCodes = zc.length;
    this.rowSelected.phonecall = this.refs.phonecall.value;

    this.props.dispatch(users.update(this.rowSelected));
    this.setState({
      isLoading: true,
    });
    setTimeout(() => {
      this.setState({
        showDialog: false,
        isLoading: false,
      });
      this.rowSelected = null;
      this.selected = null;
    }, 2000);
  }

  show(e) {
    this.rowSelected = e;
    this.setState({
      showDialog: true,
      data: e,
    });
  }

  valueChange(key, v) {
    this.rowSelected[key] = v;
  }

  showDelete(e) {
      if(this.props.auth.user._id == e._id){
        alert("Error: You are not permitted to delete yourself!")
      }else if (confirm('Do you want delete ' +  `${e.fname ? e.fname : ""} ${e.lname ? e.lname : ""}` + "?")) {
          request.get(config.apiUrl + '/user/delete/' + e._id)
              .then(() => {
                  this.loadData();
              })
      }
  }

  _onFilterChanged(filterText, list) {
    if (null == this.state.zipCodes) {
      return [];
    }

    var check = {};
    (list || []).forEach((e) => (check[e.key] = true));
    (this.props.users || []).data.forEach((e) => {
      e.zipCodes
        .split(",")
        .map((e) => e.trim())
        .filter((e) => !!e)
        .forEach((e) => (check[e] = true));
    });

    var ftext = filterText.trim().toLowerCase();
    var result = ftext
      ? []
      : [].concat(this.state.zipCodesReassign).filter((e) => !check[e]);
    if (!ftext) {
      this.state.zipCodesReassign.forEach((e) => {
        check[e] = true;
      });
    }
    for (let zipcode of this.state.zipCodes) {
      const tag = zipcode;
      if (tag.indexOf(ftext) === 0 && !check[tag]) {
        result.push(tag);
        if (result.length >= 20) break;
      }
    }
    result = result.map((e) => {
      return {
        key: e,
        name: e,
        needReAssign: false,
      };
    });

    result = result
      .map((e) => {
        if (this.state.zipCodesReassign.indexOf(e.key) >= 0) {
          e.needReAssign = true;
        }
        return e;
      })
      .sort((a, b) => {
        return a.needReAssign ? -1 : 1;
      });

    return result;
  }

  dropDownOptions() {
    if (this.props.users && this.props.users.data) {
      return this.props.users.data
        .filter((e) => e.accountType == "manager")
        .map((e) => {
          return {
            key: e._id,
            text: `${e.fname} ${e.lname} (${e.email})`,
          };
        });
    } else {
      return [];
    }
  }

  render() {
    
    var columns = this.state.columns;
    var users = this.props.users;
    if (this.props.auth.user.accountType == "admin") {
      var processCollum = columns.find((e) => e.key == "action");
      processCollum.onRender = (e) => {
        return (
          <div>
            <button className="tbl-btn" onClick={() => this.show(e)}>
              <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
            </button>
            <button className="tbl-btn" onClick={() => this.showDelete(e)}>
              <i className="ms-Icon ms-Icon--Delete" aria-hidden="true"></i>
            </button>
          </div>
        );
      };
    } else {
      columns = columns.filter((e) => e.key != "action");
    }

    var zcArray = [];
    if (this.state.data.zipCodes) {
      var tmp = this.state.data.zipCodes.split(",");
      for (var i = 0; i < tmp.length; i++) {
        zcArray.push({ key: tmp[i], name: tmp[i] });
      }
    }

    return (
      <div style={{ margin: 10 }}>
        {users.error ? (
          <div className="ms-fontColor-red">Error</div>
        ) : !users.data ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <div style={{ marginBottom: 30 }}>
            <DetailsList
              items={users.data}
              columns={columns}
              checkboxVisibility={CheckboxVisibility.hidden}
              style={{ fontSize: 14 }}
            />
            <StatusBar>
              <span>Total: {users.data.length}</span>
              {this.state.data._id && (
                <span>
                  {" "}
                  | Selected: #{users.data.indexOf(this.state.data) + 1} -{" "}
                  {`${this.state.data.fname} ${this.state.data.lname}`}{" "}
                </span>
              )}
            </StatusBar>
          </div>
        )}
        <Dialog
          isOpen={this.state.showDialog}
          title="Zip code assignment"
          isBlocking={false}
          closeButtonAriaLabel="Close"
          containerClassName="info-list-modal"
          onDismiss={() => this.close()}
        >
          <div className="ms-Grid">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  label="Name"
                  value={this.state.data.fname + " " + this.state.data.lname}
                  disabled={true}
                />
              </div>
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  label="Email"
                  value={this.state.data.email}
                  disabled={true}
                />
              </div>
              <div className="ms-Grid-col ms-u-md12">
                <TextField
                  ref="phonecall"
                  label="Twilio Phone Number"
                  value={this.state.data.phonecall}
                  disabled={this.state.data.deleted}
                />
              </div>
              {/* {this.state.data.accountType == 'staff' &&
                            <div className="ms-Grid-col ms-u-md12">
                                <Dropdown label="Manager" options={this.dropDownOptions()}
                                    selectedKey={this.state.data.managerId}
                                    onChanged={v => this.valueChange('managerId', v.key)} />
                            </div>
                        } */}
              {this.state.data.accountType == "staff" && (
                <div className="ms-Grid-col ms-u-md12">ZipCodes</div>
              )}
              {this.state.data.accountType == "staff" && (
                <div className="ms-Grid-col ms-u-md12 zipcode-assignment-tag-picker">
                  <TagPicker
                    ref="zipCodes"
                    onResolveSuggestions={this._onFilterChanged.bind(this)}
                    getTextFromItem={(item) => {
                      return item.name;
                    }}
                    onRenderSuggestionsItem={(item) => (
                      <span
                        style={{
                          color: item.needReAssign ? "blue" : "",
                          fontWeight: item.needReAssign ? "600" : "",
                        }}
                      >
                        {item.name}
                      </span>
                    )}
                    pickerSuggestionsProps={{
                      suggestionsHeaderText: "Zip Codes",
                      noResultsFoundText: "No Zip Code Found",
                    }}
                    defaultSelectedItems={zcArray}
                  />
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <PrimaryButton onClick={() => this.save()}>
              {this.state.isLoading ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Spinner size={SpinnerSize.xSmall} />
                  {" Saving..."}
                </div>
              ) : (
                <span>Save</span>
              )}
            </PrimaryButton>
            <DefaultButton onClick={() => this.close()}>Cancel</DefaultButton>
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  users: state.users,
  customer: state.customer,
}))(ZipCodeAssignment);

const accountTypeLabel = {
  staff: "Lead Generator",
  "central-user": "Central User",
  closer: "Closer",
  manager: "Manager",
  admin: "Admin",
};

const columns = [
  {
    key: "fname",
    name: "First name",
    fieldName: "fname",
    minWidth: 50,
    maxWidth: 150,
    onRender: (e) => {
      return `${e.fname ? e.fname : ""} ${e.lname ? e.lname : ""}`.trim();
    },
  },
  {
    key: "email",
    name: "Email address",
    fieldName: "email",
    minWidth: 250,
    maxWidth: 250,
  },
  {
    key: "phonecall",
    name: "Twilio Phone Number",
    fieldName: "phonecall",
    minWidth: 100,
    maxWidth: 100,
  },
  {
    key: "role",
    name: "Role",
    fieldName: "accountType",
    minWidth: 120,
    maxWidth: 120,
    onRender: (item) => {
      return accountTypeLabel[item.accountType];
    },
  },
  {
    key: "zipCodes",
    name: "List of ZIP codes",
    fieldName: "zipCodes",
    isMultiline: true,
    onRender: (item) => {
      return (item.zipCodes || "")
        .split(",")
        .map((e) => e.trim())
        .join(", ");
    },
  },
  {
    key: "noOfZipCodes",
    name: "Numbers Zip Codes",
    fieldName: "noOfZipCodes",
    minWidth: 50,
    maxWidth: 50,
    onRender: (item) => {
      return (
        item.noOfZipCodes ||
        item.zipCodes
          .split(",")
          .map((e) => e.trim())
          .filter((e) => e).length ||
        0
      );
    },
  },
  {
    key: "noOfLeads",
    name: "Numbers of Leads",
    fieldName: "noOfLeads",
    minWidth: 50,
    maxWidth: 50,
    onRender: (item) => {
      return (
        item.noOfLeads
      );
    },
  },
  {
    key: "action",
    name: "",
    fieldName: "action",
    minWidth: 80,
    maxWidth: 80,
  },
];



// WEBPACK FOOTER //
// ./client/components/ZipCodeAssignment.js